import Bowser from 'bowser';
import ApiClient from '@/client';

function injectPwaInstallPrompt() {
  var recent = document.getElementById('pwa-install-safari');
  if (recent) {
    return;
  }

  const manifest = document.querySelector('link[rel="manifest"]');

  console.log('manifest', manifest);

  const pwaInstall = document.createElement('pwa-install');
  pwaInstall.setAttribute('id', 'pwa-install-safari');
  pwaInstall.setAttribute('manifest-url', manifest.href);
  document.body.append(pwaInstall);
}

function createManifestBlobUrl(data) {
  const blob = new Blob([JSON.stringify(data)], {
    type: 'application/manifest+json'
  });
  return URL.createObjectURL(blob);
}

function injectManifestLink(data) {
  const existing = document.querySelector('link[rel="manifest"]');
  if (existing) return existing;
  const link = document.createElement('link');
  link.id = 'manifest';
  link.rel = 'manifest';
  link.href = createManifestBlobUrl(data);
  document.head.appendChild(link);
  return link;
}

// Safari, plus every other iOS browser (Chrome/CriOS, Firefox/FxiOS, Edge...).
// They all run on WebKit and their "Add to Home Screen" installs get the same
// isolated standalone storage, so they all need the OTP start_url manifest.
function isSafariBrowser() {
  try {
    const parser = Bowser.getParser(window.navigator.userAgent);
    if (parser.satisfies({ safari: '>1' })) return true;
    if (parser.getOSName(true) === 'ios') return true;
    // iPadOS 13+ reports a desktop Mac UA
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  } catch (e) {
    return false;
  }
}

let safariUserManifestPromise = null;

// iOS Safari's standalone PWA has an isolated storage sandbox (no access to
// the browser tab's localStorage/cookies), so after "Add to Home Screen" the
// launched PWA cannot read the existing auth token. To persist the session we
// fetch a user-specific manifest whose start_url carries a one-shot OTP and
// mirror that start_url onto the current tab URL via replaceState, so Safari
// captures the OTP URL on install and /login/pwa auto-logs in on launch.
async function ensureSafariUserManifest() {
  if (!isSafariBrowser()) return;
  if (safariUserManifestPromise) return safariUserManifestPromise;

  safariUserManifestPromise = (async () => {
    const response = await ApiClient.getUserManifest();
    const data = response && response.data;
    if (!data) return;

    injectManifestLink(data);
    await import('pwacompat');
    injectPwaInstallPrompt();

    const startUrlRaw = data.start_url || data.startUrl;
    if (!startUrlRaw) return;

    try {
      const startUrl = new URL(startUrlRaw, window.location.origin);
      if (startUrl.origin !== window.location.origin) return;

      const currentPathQuery =
        window.location.pathname + window.location.search;
      const targetPathQuery = startUrl.pathname + startUrl.search;
      if (currentPathQuery === targetPathQuery) return;

      window.history.replaceState(
        window.history.state,
        '',
        startUrl.pathname + startUrl.search + startUrl.hash
      );
    } catch (e) {
      console.warn('PWA: failed to sync start_url with current URL', e);
    }
  })().catch((err) => {
    safariUserManifestPromise = null;
    console.warn('PWA: failed to inject Safari user manifest', err);
  });

  return safariUserManifestPromise;
}

export { injectPwaInstallPrompt, ensureSafariUserManifest, isSafariBrowser };
